/*
 * @version: V1.0.0
 * @Date: 2023-10-31 17:40:10
 * @LastEditors: lzq
 * @LastEditTime: 2024-01-12 20:21:52
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\api\orderManage\index.js
 * @Descripttion:
 */
import request from '@/utils/request'

// 查询订单

export function getOrder(params) {
  return request({
    url: '/wms/order/list',
    method: 'get',
    params
  })
}

// 创建订单
export function saveOrder(data) {
  return request({
    url: '/wms/order',
    method: 'post',
    data
  })
}
// 关闭订单
export function closeOrder(data) {
  return request({
    url: '/wms/order/colseOrder',
    method: 'post',
    data
  })
}

// 更新订单
export function updateOrder(data) {
  return request({
    url: '/wms/order/update',
    method: 'post',
    data
  })
}

// 设置连续验货与重新验货
export function setContinue(data) {
  return request({
    url: '/wms/order/setContinue',
    method: 'post',
    data
  })
}



// 获取商品列表
export function getErrorOrderCount(params) {
  return request({
    url: '/logis-order/get_logis_order_list_by_params',
    method: 'get',
    params
  })
}

// 获取订单商品列表
export function getOrderGoods(params) {
  return request({
    url: '/wms/orderGoods/list',
    method: 'get',
    params
  })
}

// 保存订单商品信息-单个
export function saveOrderGood(data) {
  return request({
    url: '/logis-order-goods/save_logis_order_goods',
    method: 'post',
    data
  })
}


// 根据选择得产品查询对应产品得批号-单个
export function getLot(params) {
  return request({
    url: '/wms/orderGoods/getDiBatch',
    method: 'get',
    params
  })
}

// 检查订单商品是否可删除
export function checkDeleteOrderGood(ogoodsId) {
  return request({
    url: `/logis-order-goods/check_only_one_goods/${ogoodsId}`,
    method: 'get',
  })
}

// 订单商品删除
export function deleteOrderGood(ogoodsId) {
  return request({
    url: `/logis-order-goods/delete_logis_order_goods_by_id/${ogoodsId}`,
    method: 'get',
  })
}

// 修改订单指定发货日期
export function updateOrderGoodsDate(data) {
  return request({
    url: `/logis-order/save_logis_order`,
    method: 'post',
    data
  })
}






// 获取完整订单信息
export function getOrderInfo(orderId) {
  return request({
    url: `/wms/order/getOutPrintInfo/${orderId}`,
    method: 'get',
  })
}

// 获取路由信息
export function getRouteInfo(orderId, type) {
  return request({
    url: `/logistics/get_route-v2/${orderId}`,
    method: 'get',
    params: {
      type
    }
  })
}
// 获取信息
export function getMailInfoV2(orderId) {
  return request({
    url: `/logistics/get_mail_info-v2/${orderId}`,
    method: 'get',
  })
}



// 获取拣货单列表
export function getPickingList(params) {
  return request({
    url: `/wms/order/getPickingList`,
    method: 'get',
    params
  })
}

// 获取销售出库单
export function getSalesOrders(params) {
  return request({
    url: `/wms/order/getSaleStockList`,
    method: 'get',
    params
  })
}

// 根据快递回单登记是否签回
export function registrationExpressSignBack(params) {
  return request({
    url: `/logis-mail-info/registration_express_sign_back`,
    method: 'get',
    params
  })
}

// 获取次月揽件表里订单创建时间为上月的数据
export function getCreatedLastMonthList(params) {
  return request({
    url: `/logis-next-month-lj/get_created_last_month_list`,
    method: 'get',
    params
  })
}

// 登记表
export function getRegist(params) {
  return request({
    url: `/logistics/get_registration_form_list-v2`,
    method: 'get',
    params
  })
}

// 获取产品列表
export function getProduct(params) {
  return request({
    url: `/material/list`,
    method: 'get',
    params
  })
}

// 获取已入库产品列表
export function getInStockProduct(params) {
  return request({
    url: `/wms/stock/listProduct`,
    method: 'get',
    params
  })
}

// 获取已验货列表
export function getInspectedList(params) {
  return request({
    url: `/wms/orderInst/list`,
    method: 'get',
    params
  })
}

// 获取已有客户
export function getCustomer(params) {
  return request({
    url: `/wms/order/getCustomerName`,
    method: 'get',
    params
  })
}

// 获取已有部门
export function getOrg(params) {
  return request({
    url: `/wms/order/getOrgName`,
    method: 'get',
    params
  })
}

// 获取验货表信息
export function getInspectionInfoByOrderId(params) {
  return request({
    url: `/wms/orderGoods/list`,
    method: 'get',
    params
  })
}

// 获取拣货单列表
export function getPickingOrder(params) {
  return request({
    url: `/wms/orderGoods/list`,
    method: 'get',
    params
  })
}

// 更新打印数量
export function updatePrintNum(params) {
  return request({
    url: `/logis-order-goods/update_so_print_status`,
    method: 'get',
    params
  })
}

// 更新打印状态
export function updatePrintStatus(data) {
  return request({
    url: `/wms/order/picking`,
    method: 'post',
    data
  })
}

// 拣货单多个打印查询
export function getPrintPickingOrder(ids) {
  return request({
    url: `/wms/order/getOutPrintInfoList/${ids}`,
    method: 'get',
  })
}

// 判断是否箱内DI产品未绑定物料
export function checkDIBind(params) {
  return request({
    url: `/material/verifySonDiCode`,
    method: 'get',
    params
  })
}

// 获取库存数量

export function getWareHouseNumber(params) {
  return request({
    url: `/wms/stock/getStock`,
    method: 'get',
    params
  })
}

// 查询出库实例数据列表
export function getStockRemovalUdiCode(params) {
  return request({
    url: `/wms/orderInst/pageQuery`,
    method: 'get',
    params
  })
}

// 整单
export function exportAllOrderUdiData(orderId) {
  return request({
    url: `/wms/orderInst/exportAllOrderUdiData?orderId=`+orderId,
    method: 'post',
    responseType: 'blob',
    timeout : 1000 * 60 * 10 // 设置10分钟超时
  })
}

// DI导出
export function exportUdiData(data) {
  return request({
    url: `/wms/orderInst/exportUdiData`,
    method: 'post',
    responseType: 'blob',
    data,
    timeout : 1000 * 60 * 10 // 设置10分钟超时
  })
}
